import { Dialog, DialogContent } from 'components/UI/Modal/ModalPrimitive'
import { useEffect } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { ProductDetailsStep } from './ProductDetailsStep'
import { ProductModalProvider } from './ProductModalContext'
import { ProductVariantsStep } from './ProductVariantsStep'
import { SalesPotentialStep } from './SalesPotentialStep'

export function ProductModal({
  show,
  handleClose,
  selectedProductID,
  defaultValues,
  productForm,
  espForm,
  onSubmit,
  step,
  setStep,
}: {
  show: boolean
  handleClose: () => void
  selectedProductID?: number
  defaultValues: any
  productForm: UseFormReturn<any>
  espForm: UseFormReturn<any>
  onSubmit: () => Promise<void>
  step: number
  setStep: (step: number) => void
}) {
  // Always show 3 steps (Details → Sales Potential → Variants)
  const totalSteps = 3

  // Reset step when modal closes
  useEffect(() => {
    if (!show) {
      setStep(0)
    }
  }, [show])

  // Create a wrapper for handleClose that ensures step is reset
  const handleModalClose = () => {
    setStep(0)
    handleClose()
  }

  return (
    <Dialog open={show} onOpenChange={(open) => !open && handleModalClose()}>
      <DialogContent id={'fb-modal-content'} size="lg" className="px-3">
        <ProductModalProvider
          handleClose={handleModalClose}
          selectedProductID={selectedProductID}
          defaultValues={defaultValues}
          productForm={productForm}
          espForm={espForm}
          onSubmit={onSubmit}
        >
          {step === 0 && (
            <ProductDetailsStep
              onNext={() => setStep(1)}
              totalSteps={totalSteps}
            />
          )}
          {step === 1 && (
            <SalesPotentialStep
              onBack={() => setStep(0)}
              onNext={() => setStep(2)}
              totalSteps={totalSteps}
            />
          )}
          {step === 2 && (
            <ProductVariantsStep
              onBack={() => setStep(1)}
              isNewCatalog={true}
            />
          )}
        </ProductModalProvider>
      </DialogContent>
    </Dialog>
  )
}
